// extracted by mini-css-extract-plugin
export default {"card":"styles_card__FN-Bl","item_text":"styles_item_text__85HQ1","item_icon":"styles_item_icon__FAbLl","weight":"styles_weight__4Oxmy","item_code":"styles_item_code__DFaeD"};